import React , { useState, useEffect } from 'react';
import { Select } from '@windmill/react-ui';
import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectVehicleCatBasic = ({register, name, label,selectedVehicle,readOnly ,selectedOptions, onPrimeStatusChange, ...props}) => {
  
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await VehicleCategoryServices.getAllVehicleCategory();
        setVehicleCategory(response.data); // Assuming the API response contains an array of profiles
      } catch (error) {
        console.error('Error fetching category:', error);
      }
    }
  
    fetchVehicleCategory();
  }, []);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    const selectedCategory = allVehicleCategory.find(
      (category) => String(category.id) === selectedId
    );
    onPrimeStatusChange(selectedCategory?.is_prime || false);
  };

  return (
    <Select
    
    className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
    name={name}
    {...register(`${name}`, {
      required: !selectedVehicle || selectedVehicle === 'undefined' ? `${label} is required!` : false,
    })}
    value={selectedVehicle ? String(selectedVehicle) : ""}
    {...props}
    disabled={readOnly}
    onChange={(e) => {
        handleChange(e);
        if (props.onChange) {
          props.onChange(e);  
        }
      }}
  >
    <option value="">Select Vehicle</option>
    {Array.isArray(allVehicleCategory) && allVehicleCategory.length > 0 ? (
      allVehicleCategory
        .filter(category => !selectedOptions.includes(String(category.id)) || String(category.id) === selectedVehicle)
        .map(category => (
          <option key={category.id} value={category.id}>
            {category.vehicle_type_name}
          </option>
        ))
    ) : (
      <option>Loading...</option>
    )}
  </Select>
  
  
    
  );
};

export default SelectVehicleCatBasic;